import { render, staticRenderFns } from "./TranslationRequestForm.vue?vue&type=template&id=0c8fca1b"
import script from "./TranslationRequestForm.vue?vue&type=script&lang=js"
export * from "./TranslationRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports